import { useCallback, useEffect, useState } from "react";
import ExamTopBar from "../../../components/Bars/ExamTopBar";
import ExamQuestionPanel from "./ExamQuestionPanel";
import ExamOptionsPanel from "./ExamOptionsPanel";
import SubmitModule from "./SubmitModule";
import ExamLoadingModule from "./ExamLoadingModule";
import { ConfirmationModule, WarningModule } from "../../../components";
import {
  handleFullScreen,
  sendExamSubmitEmail,
  submitExam,
  useFetchExamDetails,
  useFetchExamQues,
  useDevToolsCheck,
  useFullScreenDetection,
  usePreventCopyPasteScrnShot,
  useTabSwithcDetection,
  useTerminateOnRefresh,
} from "./examFunctions";
import CameraProctoring from "./proctoring/CameraProctoring";
import MicProctoring from "./proctoring/MicProctoring";
import { violationTypes } from "../../../constant/violationTypes";

const ExamPage = () => {
  //states
  const [qusNum, setQusNum] = useState(0);
  const [startTime, setStartTime] = useState();
  const [timer, setTimer] = useState(60);
  const [timerPause, setTimerPause] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState([]);
  const [confirmationButton, setConfirmationButton] = useState([]);
  const [warningCount, setWarningCount] = useState(0);
  const [warningType, setWarningType] = useState("");
  const [warningMessage, setWarningMessage] = useState([]);
  const [violations, setViolations] = useState([]);
  const [maxViolations] = useState(5);
  const [showWarning, setShowWarning] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showSubmitModule, setShowSubmitModule] = useState(false);
  const [assessmentResults, setAssessmentResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingPercent, setLoadingPercent] = useState(0);
  const [cameraProctorLoading, setCameraProctorLoading] = useState(true);
  const [micProctorLoading, setMicProctorLoading] = useState(true);
  const [cameraDetection, setCameraDetection] = useState(false);
  const [isListening, setIsListening] = useState(false);

  // fetch participantDetails details
  const participantDetails = useFetchExamDetails();

  // fetch questions
  const {
    questions,
    loading: questionLoading,
    error: questionError,
    // progress: questionLoadingProgress,
  } = useFetchExamQues({ participantDetails });

  useEffect(() => {
    // !questionLoading && setLoading(false);
    // if (!questionLoading && !cameraProctorLoading && !micProctorLoading) {
    if (!questionLoading) {
      setLoading(false);
      setIsListening(true);
      setCameraDetection(true);
    }
    // setLoadingPercent(Math.round(questionLoadingProgress));
  }, [
    questionLoading,
    cameraProctorLoading,
    micProctorLoading,
    // questionLoadingProgress,
  ]);

  //  start timer
  useEffect(() => {
    setStartTime(new Date());
    setTimer(questions[0]?.time);
  }, [questions]);

  // function to trigger a violation
  const showViolations = useCallback((type) => {
    setTimerPause(true);
    setCameraDetection(false);
    setIsListening(false);
    type !== "voice" &&
      setViolations((prev) => [...prev, violationTypes[type]?.violation]);
    type !== "voice" && setWarningCount((prev) => prev + 1);
    setWarningType(type);
    setWarningMessage(violationTypes[type].message);
    setShowWarning(true);
  }, []);

  // hide warning Module
  const hideModule = () => {
    if (warningCount === maxViolations - 1) {
      setWarningMessage([
        `This is your last warning`,
        "If you violate the assessment rules again, Your assessment will be terminated.",
      ]);
      setWarningType("lastWarning");
    } else {
      closeWarning();
    }
  };
  const closeWarning = () => {
    handleFullScreen();
    setShowWarning(false);
    setTimerPause(false);
    // setcellPhoneDetection(0);
    setIsListening(true);
    setCameraDetection(true);
  };

  // Browser Proctoring
  // const refreshViolation = useTerminateOnRefresh();
  const fullScreenViolation = useFullScreenDetection();
  const tabSwitchViolation = useTabSwithcDetection();
  const screenShotViolation = usePreventCopyPasteScrnShot();
  const { violation: devToolViolation, closeDevTools } = useDevToolsCheck();
  useEffect(() => {
    fullScreenViolation && showViolations("fullScreen");
    tabSwitchViolation && showViolations("tabSwitch");
    screenShotViolation && showViolations("screenShot");
    devToolViolation && !closeDevTools && showViolations("devtools");
    closeDevTools && setWarningType("devtools-close");
    // refreshViolation && showViolations("refresh");
  }, [
    tabSwitchViolation,
    fullScreenViolation,
    screenShotViolation,
    devToolViolation,
    closeDevTools,
    showViolations,
    // refreshViolation,
  ]);

  // Screen Recording - TODO: Need to be worked on
  // Access recording state from Redux
  // const recordingStatus = useSelector(
  //   (state) => state.screenRecording.recordingStatus
  // );
  // const mediaBlobUrl = useSelector(
  //   (state) => state.screenRecording.mediaBlobUrl
  // );
  // const recordingError = useSelector((state) => state.screenRecording.error);

  // const dispatch = useDispatch();
  // useEffect(() => {
  //   // Clean up recording state on component unmount
  //   return () => {
  //     dispatch(clearRecording());
  //   };
  // }, [dispatch]);

  // useEffect(() => {
  //   // Show warning if recording stops before exam submission
  //   if (recordingStatus === "stopped") {
  //     showViolations("screen-rec-stopped");
  //   }
  // }, [recordingStatus, mediaBlobUrl, showViolations]);

  // const handleRestartRecording = async () => {
  //   try {
  //     // 1. Stop existing recording (if any)
  //     if (recordingStatus === "recording" || recordingStatus === "stopped") {
  //       await dispatch(stopRecordingThunk());
  //     }

  //     // 2. Clear any previous recording data and errors
  //     dispatch(clearRecording());

  //     // 3. Start a new recording
  //     await dispatch(startRecordingThunk());

  //     // 4. Hide the warning
  //     // setShowRecordingWarning(false);
  //   } catch (error) {
  //     console.error("Error restarting recording:", error);
  //     // ... Handle error (e.g., display error message) ...
  //   }
  // };

  // handle Terminate
  const handleTerminate = () => {
    // setViolations([...(violations + "terminate")]);
    setShowWarning(false);
    handleSubmit();
  };

  // skip confirmation module
  const alertSkip = () => {
    setTimerPause(true);
    setConfirmationMessage([
      "Do you want to skip ?",
      "You will not be able to come back to this Question later.",
    ]);
    setConfirmationButton(["Skip Question", "Back to Question"]);
    setShowConfirmation(true);
  };

  //confirm skip
  const confirmSkip = () => {
    handleNext("");
    cancelAlert();
  };

  //cancel module
  const cancelAlert = () => {
    setShowConfirmation(false);
    setTimerPause(false);
  };

  //submit confirmation module
  const alertSubmit = () => {
    setTimerPause(true);
    setConfirmationMessage(["Submit the test ?"]);
    setConfirmationButton(["Submit"]);
    setShowConfirmation(true);
  };

  //confirm submit
  const confirmSubmit = async () => {
    setTimerPause(true);
    await handleSubmit();
    setShowConfirmation(false);
  };

  //next question button
  const handleNext = (userAnswer) => {
    const question = questions[qusNum];
    let evaluation =
      userAnswer === ""
        ? "unattempted"
        : Number(userAnswer) === Number(question?.correct)
        ? "correct"
        : "incorrect";

    const quesResult = {
      questionNo: qusNum + 1,
      question: question,
      userAnswer: userAnswer || "unattempted",
      violations: violations,
      evaluation: evaluation,
    };
    setAssessmentResults((prev) => [...prev, quesResult]);

    if (qusNum < questions.length - 1) {
      setQusNum((prev) => prev + 1);
      setTimer(questions[qusNum + 1]?.time);
    } else {
      alertSubmit();
    }
  };

  //submit exam
  const [submitLoading, setSubmitLoading] = useState(false);
  const handleSubmit = async () => {
    cancelAlert();
    setTimerPause(true);
    setSubmitLoading(true);
    // stop all proctoring
    try {
      await submitExam({
        results: assessmentResults,
        startTime,
        participantId: participantDetails.enrollmentNo,
      });

      await sendExamSubmitEmail({ participantName: participantDetails?.name });
    } catch (error) {
      // setError(error);
      console.log(error);
    } finally {
      setSubmitLoading(false);

      // show exam submit module
      setShowSubmitModule(true);

      // clear local storage
      localStorage.removeItem("refresh");
      // localStorage.removeItem("practido-examAuth");  TODO: to be uncommitted
    }
  };

  // Time's Up
  const handleTimeUp = () => {
    if (qusNum !== questions.length - 1) {
      handleNext("");
    } else {
      confirmSubmit();
    }
  };

  return (
    <div
      className="relative bg-gray-300 w-full h-[100vh] flex flex-col items-center justify-center"
      onContextMenu={(e) => e.preventDefault()}
    >
      <ExamTopBar
        placememt="examPage"
        name={participantDetails?.name}
        participantClass={participantDetails?.className}
        subject={participantDetails?.examSubject}
        qusNum={qusNum}
        duration={timer}
        timeUp={handleTimeUp}
        timerPause={timerPause}
        loading={loading}
      />

      <div className="absolute top-2 left-[50%] translate-x-[-50%] z-50">
        <CameraProctoring
          loading={loading}
          // setLoadingPercent={setLoadingPercent}
          setCameraProctorLoading={setCameraProctorLoading}
          cameraDetection={cameraDetection}
          showViolations={showViolations}
          setWarningType={setWarningType}
        />
        <MicProctoring
          isListening={isListening}
          setIsListening={setIsListening}
          showViolations={showViolations}
          setMicProctorLoading={setMicProctorLoading}
          // setLoadingPercent={setLoadingPercent}
        />
      </div>

      {loading && (
        <div className="absolute w-full h-[100vh] top-0 left-0 z-30 flex justify-center items-center bg-black/[0.15] backdrop-blur-[4px]">
          <ExamLoadingModule loadingPercent={loadingPercent} />
        </div>
      )}

      <div className="absolute w-[95%] top-40 h-[78%] flex bg-[white] rounded-xl overflow-hidden p-6">
        <ExamQuestionPanel
          questions={questions}
          qusNum={qusNum}
          loading={loading}
        />
        <ExamOptionsPanel
          loading={loading}
          questions={questions}
          qusNum={qusNum}
          handleNext={handleNext}
          alertSkip={alertSkip}
        />
      </div>

      {showConfirmation && (
        <div id="confirmationModule" className="moduleCover">
          <ConfirmationModule
            confirmationMessage={confirmationMessage}
            confirmationButton={confirmationButton}
            cancelAlert={cancelAlert}
            confirmSkip={confirmSkip}
            confirmSubmit={handleSubmit}
            submitLoading={submitLoading}
          />
        </div>
      )}

      {showWarning && (
        <div id="warningModule" className="moduleCover">
          <WarningModule
            type={warningType}
            warningCount={warningCount}
            warningMessage={warningMessage}
            hideModule={hideModule}
            maxViolations={maxViolations}
            closeWarning={closeWarning}
            handleTerminate={handleTerminate}
          />
        </div>
      )}

      {showSubmitModule && (
        <div className="flex w-full h-full fixed top-0 left-0 z-30 justify-center items-center">
          <SubmitModule name={participantDetails?.name} />
        </div>
      )}
    </div>
  );
};

export default ExamPage;
